import { render, staticRenderFns } from "./textTitle.vue?vue&type=template&id=8201573e&scoped=true"
import script from "./textTitle.vue?vue&type=script&lang=js"
export * from "./textTitle.vue?vue&type=script&lang=js"
import style0 from "./textTitle.vue?vue&type=style&index=0&id=8201573e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8201573e",
  null
  
)

export default component.exports